export default {
    createBranch: 'สร้างสาขา',
    updateBranch: 'แก้ไขสาขา',
    branchName: 'ชื่อสาขา',
    branchAddress: 'ที่อยู่สาขา',
    contactPerson: 'ชื่อผู้ติดต่อ',
    contactPhoneNumber: 'เบอร์โทรผู้ติดต่อ',
    save: 'บันทึก',
    thisFieldIsRequired: 'กรุณากรอกข้อมูล',
    incorrectPhoneNubmer: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
    thisFieldIsExceededCharacters: 'ข้อความเกิน 255 ตัวอักษร',
    congratulation: 'ยินดีด้วย',
    errorMessage: 'เกิดข้อผิดพลาด',
    branchIsCreated: 'สาขาถูกสร้างแล้ว',
    branchIsUpdated: 'สาขาถูกอัปเดตแล้ว'
}
